import {
  type GatewaySocket,
  useGatewaySocket as useBaseGatewaySocket,
} from '@avila-roffe/settings';
import * as React from 'react';
import { useAuthStore } from '../stores/authStore';
import { useHitlStore } from '../stores/hitlStore';
import type {
  AgentQueryEvent,
  TaskCancelledEvent,
  TaskDispatchedEvent,
  TaskResumedEvent,
} from '../types/socket';

export type { UseGatewaySocketResult } from '@avila-roffe/settings';
export { getActiveWorkItemId, setActiveWorkItemId } from '@avila-roffe/settings';

export function useGatewaySocket() {
  const bffToken = useAuthStore((state) => state.accessToken);
  const getToken = React.useCallback(() => bffToken, [bffToken]);

  const onSocketReady = React.useCallback((sock: GatewaySocket) => {
    sock.on('task_dispatched', (event: TaskDispatchedEvent) => {
      sock.emit('subscribe_task', { type: 'subscribe_task', workItemId: event.workItemId });
    });

    sock.on('agent_query', (event: AgentQueryEvent) => {
      useHitlStore.getState().setPendingQuery(event.workItemId, event);
    });

    sock.on('task_resumed', (event: TaskResumedEvent) => {
      useHitlStore.getState().clearPendingQuery(event.workItemId);
    });

    sock.on('task_cancelled', (event: TaskCancelledEvent) => {
      useHitlStore.getState().clearPendingQuery(event.workItemId);
    });
  }, []);

  return useBaseGatewaySocket(getToken, undefined, onSocketReady);
}
